import { apiSlice } from "./apiSlice";

import { BILLINGDASHBOARD_URL } from "../constants";

export const billingDashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // =====================================================
    // Get Billing Dashboard Summary
    //
    // GET /api/billing/dashboard
    //
    // =====================================================

    getBillingDashboard: builder.query({
      query: () => ({
        url: `${BILLINGDASHBOARD_URL}/dashboard`,
      }),

      providesTags: ["BillingDashboard"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Get Coaching Center Billing History
    //
    // GET /api/billing/center/:centerId/history
    //
    // =====================================================

    getCenterBillingHistory: builder.query({
      query: (centerId) => ({
        url: `${BILLINGDASHBOARD_URL}/center/${centerId}/history`,
      }),

      providesTags: ["BillingDashboard"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Get Monthly Revenue Report
    //
    // GET /api/billing/dashboard/monthly-revenue
    //
    // Query:
    // {
    //   year: 2026
    // }
    //
    // =====================================================

    getMonthlyRevenue: builder.query({
      query: (params) => ({
        url: `${BILLINGDASHBOARD_URL}/dashboard/monthly-revenue`,
        params,
      }),

      providesTags: ["BillingDashboard"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Get Outstanding Invoices
    //
    // GET /api/billing/dashboard/outstanding
    //
    // Query:
    // {
    //   page,
    //   limit,
    //   search,
    //   center
    // }
    //
    // =====================================================

    getOutstandingInvoices: builder.query({
      query: (params) => ({
        url: `${BILLINGDASHBOARD_URL}/dashboard/outstanding`,
        params,
      }),

      providesTags: ["BillingDashboard"],

      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetBillingDashboardQuery,

  useGetCenterBillingHistoryQuery,

  useGetMonthlyRevenueQuery,

  useGetOutstandingInvoicesQuery,
} = billingDashboardApiSlice;
